// Ported verbatim from the source repository (client/src/lib/format.js).
// Presentation helpers shared across the Harborlight screens.

export function formatMoney(value: unknown): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(Number(value || 0));
}

export function formatDate(value: unknown): string {
  if (!value) return '—';
  return new Date(value as string).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function statusBadgeClass(status: unknown): string {
  return `badge rounded-pill badge-${String(status || '')
    .toLowerCase()
    .replace(/\s+/g, '_')}`;
}

export function roomMediaClass(type: unknown): string {
  return `room-tile-media type-${String(type || 'standard').toLowerCase()}`;
}
